
/**
 * status store types
 */

const mutationTypes = {
  STATUS_SET_BROWSER: 'setBrowser',
  STATUS_SET_POPSTATE: 'setPopstate'
}
const actionTypes = {
  STATUS_INIT_BROSWER: 'initBroswer'
}

module.exports = {
  mutationTypes,
  actionTypes
}



// WEBPACK FOOTER //
// ./src/store/types/status.js